import React from "react";
import styles from "./Range.module.scss";

const Range = ({ min = 10, step = 1, onChange, ref, max = 50, childen, className = "", variant, value }) => {
  const changeValue = (e) => onChange(e.target.value);
  return (
    <div className={`${styles.Range} ${variant ? styles[variant] : ""} ${className}`}>
      <input
        onChange={changeValue}
        id="rangeInput"
        type="range"
        value={value !== undefined ? value : undefined}
        defaultValue={value === undefined ? 1 : undefined}
        min={min}
        step={step}
        max={max}
      />
    </div>
  );
};

export default Range;